module.exports = __webpack_public_path__ + "assets/img_valid.1e813a91.svg";